<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>销售文章</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form
          ref="queryForm"
          :model="searchForm"
          inline
          style="margin-left: 8vh"
        >
          <el-form-item style="margin-bottom: 0">
            <el-input
              v-model="searchForm.title"
              autocomplete="off"
              maxlength="30"
              placeholder="文章标题"
              clearable
              @change="searchChange"
              size="small"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchChange"
              size="mini"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="handleNewAdd"
          size="mini"
          >新增文章</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="sort" label="排序" align="center" />
      <el-table-column prop="title" label="文章标题" align="center" />
      <el-table-column
        prop="default_hot_num"
        label="文章封面"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
  <div>
    <template v-if="Array.isArray(JSON.parse(scope.row.article_imgs)) && JSON.parse(scope.row.article_imgs).length > 1">
      <el-image
        v-for="(img, index) in JSON.parse(scope.row.article_imgs)"
        :key="index"
        style="width: 50px; height: 50px; margin-right: 5px"
        :src="img"
        :preview-src-list="JSON.parse(scope.row.article_imgs)"
      />
    </template>
    <template v-else-if="Array.isArray(JSON.parse(scope.row.article_imgs)) && JSON.parse(scope.row.article_imgs).length === 1">
      <el-image
        style="width: 50px; height: 50px; margin-right: 5px"
        :src="JSON.parse(scope.row.article_imgs)[0]"
        :preview-src-list="[JSON.parse(scope.row.article_imgs)[0]]"
      />
    </template>
    <template v-else>
      <div class="image-slot">
        <span style="line-height: 50px">暂无图片</span>
      </div>
    </template>
  </div>
</template>
      </el-table-column>
      <el-table-column prop="hot_num" label="点击热度" align="center" />
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.pageSize"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="45%"
      class="dialogHeight2 global-dialog-position"
      :before-close="getout"
      :lock-scroll="false"
      :append-to-body="true"
      style="margin-top: -10vh"
    >
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="文章标题" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="点击热度" prop="hot_num">
              <el-input
                v-model="form.hot_num"
                autocomplete="off"
                placeholder="请输入"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排序">
              <el-input
                v-model="form.sort"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
              <el-form-item label="文章状态" prop="status">
                <el-radio-group v-model="form.status">
                  <el-radio
                    v-for="item in regionTypes"
                    :label="item.label"
                    :key="item.label"
                    >{{ item.text }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-col> -->

          <el-col :span="24">
            <el-form-item label="封面图片">
              <el-upload
                :class="{ uploadSty: showBtnImg, disUploadSty: noneBtnImg }"
                ref="upload"
                list-type="picture-card"
                :limit="limit"
                :action="uploadImgUrl"
                :headers="headers"
                :on-change="imgChange"
                :file-list="conTypeFiles"
                :on-success="handleAvatarSuccess"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload"
                :on-exceed="handleExceed"
                :on-preview="handlePictureCardPreview"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div style="color: #999; margin-top: -2vh">
                图片大小建议400*300
              </div>
              <el-dialog :visible.sync="dialogVisible" style="z-index: 9999">
                <img width="100%" :src="imageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="图片地址"
              v-for="(item, index) in conTypeArr"
              :key="index"
            >
              <div class="chooseImg">
                <el-button type="info" @click="chooseImg(index)"
                  >选择图片</el-button
                >
                <el-input
                  v-model="item.url"
                  autocomplete="off"
                  placeholder="请输入"
                >
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="文章内容">
              <el-button type="primary" @click="clickArc" icon="el-icon-edit"
                >写文章</el-button
              >
              <i class="el-icon-circle-check alright" v-if="contentIf"></i>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibles" style="z-index: 9999">
      <img width="100%" :src="imageUrl" alt="" />
    </el-dialog>
    <el-dialog
      title="图片"
      :visible.sync="upImg"
      :close-on-click-modal="false"
      width="85%"
      class="dialogHeight global-dialog-position"
      style="margin-top: -7vh"
    >
      <imgUpload ref="imgUpload" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormz">确 定</el-button>
        <!-- <el-button @click="getout">取 消</el-button> -->
      </div>
      <div slot="body" style="height: 50vh"></div>
    </el-dialog>
    <el-dialog
      title="写文章"
      :visible.sync="arcIf"
      :close-on-click-modal="false"
      width="85%"
      class="arcWrite global-dialog-position"
      style="margin-top: -12vh"
    >
      <div style="border: 1px solid #ccc; margin-top: -2vh; width: 100%">
        <Toolbar
          style="border-bottom: 1px solid #ccc"
          :editor="editor"
          :defaultConfig="toolbarConfig"
          :mode="mode"
        />
        <Editor
          style="height: 60vh; overflow-y: hidden"
          v-model="html2"
          :defaultConfig="editorConfig"
          :mode="mode"
          @onCreated="onCreated"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormA">确 定</el-button>
        <!-- <el-button @click="getout">取 消</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>
      
      <script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

import tableCommon from "../../../mixins/table-common";
import {
  getpriseList,
  addprise,
  editprise,
  deleteprise,
} from "../../api/enterprise";
import { getCookie } from "../../utils/util";
import imgUpload from "../../components/uploadImg.vue";

export default {
  mixins: [tableCommon],
  components: {
    imgUpload,
    Editor,
    Toolbar,
  },
  data() {
    return {
      editor: null,
      html2: "",
      toolbarConfig: {
        excludeKeys: ["group-video"],
      },
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          uploadImage: {
            server: process.env.VUE_APP_URL + "/admin/uploadFile",
            fieldName: "file",
            // 上传头文件
            headers: {
              Authorization: "Bearer " + getCookie("logintoken"),
            },
            customInsert(res, insertFn) {
              // JS 语法
              const urls = res.data.path;
              insertFn(urls);
            },
          },
        },
      },
      mode: "default", // or 'simple'

      arcIf: false,
      upImg: false,
      dialogVisibles: false,
      dialogVisible: false,
      regionTypes: [
        {
          label: 1,
          text: "显示",
        },
        {
          label: 0,
          text: "关闭",
        },
      ],
      limit: 3,
      showBtnImg: true,
      noneBtnImg: false,
      // 图片数组
      conTypeFiles: [],
      // 请求地址api
      api: {
        list: getpriseList,
        add: addprise,
        del: deleteprise,
        edit: editprise,
      },
      // 规则验证
      rules: {
        category_ids: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        status: [{ required: true, message: "请选择", trigger: "change" }],
      },
      // 传参
      form: {},
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 分类数组
      classArr: [],
      // 查询参数
      searchForm: {
        page: 1,
        pageSize: 15,
      },
      tableData: [],
      // 小区数组
      xiaoquArr: [],
      communityData: [],
      // 图片
      imageUrl: "",
      // 上传头文件
      headers: {
        Authorization: "Bearer " + getCookie("logintoken"),
      },
      // 图片上传地址
      uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
      // 处理图片数组
      dealPic: [],
      // 标签下拉列表
      tagGroup: [],
      // 图片组
      conTypeArr: [],
      imgFirst: false,
      imgSecond: false,
      imgThird: false,
      // 文章内容判断
      contentIf: false,
      oldHtml: "",
      count: 0,
    };
  },
  watch: {
    upImg(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.imgUpload.resetSelect();
        });
      }
    },

    "form.content": function (newVal, oldVal) {
      this.count++; // 每次变化，计数器加1

      if (this.count === 2) {
        // 判断是否是第二次变化
        // 在这里执行相应的操作，比如验证、保存数据等
        if (newVal) {
          this.contentIf = true;
        }
      } else {
        this.contentIf = false;
      }
    },
    conTypeArr: {
      handler(newArr) {
        this.conTypeFiles = newArr.filter((item) => item.url !== "");
        this.noneBtnImg = this.conTypeFiles.length >= this.limit;
      },
      deep: true,
    },
  },
  methods: {
    // 文章确定
    submitFormA() {
      this.form.content = this.editor.getHtml();
      this.arcIf = false;
      //   console.log(this.editor.getHtml());
    },
    // async submitFormArc(res) {
    //   try {
    //     this.$refs["form"].validate((valid, err) => {
    //       if (valid) {
    //         this.btnLoading = true;
    //         if (this.actionType === "edit") {
    //           let fn = this.api.edit;
    //           fn(this.form).then((response) => {
    //             this.initList();
    //           });
    //         } else if (this.actionType === "add") {
    //           let fn = this.api.add;
    //           fn(this.form).then((response) => {
    //             this.initList();
    //           });
    //         }
    //       } else {
    //         this.form.category_ids = res.split(",");
    //         if (this.isFormErr) {
    //           Object.keys(err).map((key) => {
    //             setTimeout(() => {
    //               this.$modal.msgError(err[key][0].message);
    //             }, 100);
    //           });
    //         }
    //       }
    //     });
    //   } catch (err) {
    //     this.btnLoading = false;
    //   }
    // },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    // 获取配置
    getbaseLists() {
      getBaseList().then((res) => {
        console.log(res);
      });
    },
    beforeDestroy() {
      const editor = this.editor;
      if (editor == null) return;
      editor.destroy(); // 组件销毁时，及时销毁编辑器
    },
    // 文章内容
    clickArc() {
      this.arcIf = true;
      this.oldHtml = this.html2;
      this.html2 = this.form.content;
    },
    submitFormz() {
      if (this.$refs.imgUpload.faData.url) {
        if (this.imgFirst && this.$refs.imgUpload.faData.url !== undefined) {
          this.$refs.imgUpload.findTrue();

          this.conTypeArr[0].url = this.$refs.imgUpload.faData.url;
        } else if (
          this.imgSecond &&
          this.$refs.imgUpload.faData.url !== undefined
        ) {
          this.$refs.imgUpload.findTrue();

          this.conTypeArr[1].url = this.$refs.imgUpload.faData.url;
        } else if (
          this.imgThird &&
          this.$refs.imgUpload.faData.url !== undefined
        ) {
          this.$refs.imgUpload.findTrue();

          this.conTypeArr[2].url = this.$refs.imgUpload.faData.url;
        }
        this.$refs.imgUpload.faData.url = "";
        this.$refs.imgUpload.getimgLists();
        this.upImg = false;
      } else {
        this.$message.warning("请选择一张照片");
      }
    },
    chooseImg(res) {
      if (res === 0) {
        this.imgSecond = false;
        this.imgThird = false;
        this.imgFirst = true;
      } else if (res === 1) {
        this.imgFirst = false;
        this.imgThird = false;
        this.imgSecond = true;
      } else if (res === 2) {
        this.imgFirst = false;
        this.imgSecond = false;
        this.imgThird = true;
      }
      this.upImg = true;
    },
    // 预览
    handlePictureCardPreview(file) {
      this.imageUrl = file.url;
      this.$nextTick(() => {
        this.dialogVisibles = true;
      });
    },
    // 改变状态
    changeStatus(res) {
      this.form = JSON.parse(JSON.stringify(res));
      // this.handleEdit();
      this.actionType = "edit";
      delete this.form.duration;
      delete this.form.video_img;
      delete this.form.xiaoqu_name;
      // const { city_name, company_name, ...rest } = this.form;
      // this.form = rest;
      editprise(this.form).then((msg) => {
        if (msg.code !== 200) return this.$message("获取状态失败");
      });
    },
    imgChange(file, fileList) {
      this.noneBtnImg = fileList.length >= this.limit;
    },
    getCategory(res) {},
    // 移除照片
    handleRemove(res, req) {
      this.conTypeFiles = req;
      this.conTypeArr = JSON.parse(JSON.stringify(req));
      if (this.conTypeArr.length < 3) {
        const difference = 3 - this.conTypeArr.length;
        for (let i = 0; i < difference; i++) {
          this.conTypeArr.push({ url: "" }); // 替换"your_default_url"为您想要添加的默认URL
        }
      }
      this.noneBtnImg = req.length >= this.limit;
    },
    handleExceed(files, fileList) {
      this.$message.error(` 一次最多上传3张! `);
    },
    // 上传图片
    handleAvatarSuccess(res, file, list) {
      this.imageUrl = res.data.path;
      this.form.article_imgs = this.imageUrl;
      this.conTypeFiles.push({ url: file.response.data.path });
      for (let i = 0; i < this.conTypeArr.length; i++) {
        if (!this.conTypeArr[i].url || this.conTypeArr[i].url === "") {
          this.conTypeArr[i].url = file.response.data.path;
          break; // 找到第一个满足条件的元素后，中断循环
        }
      }
      //   this.form.sales_img = this.imageUrl;
      //   console.log(this.imageUrl);
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/gif" ||
        file.type === "image/jpeg" ||
        file.type === "image/webp";
      const isLt2M = file.size / 1024 / 1024 < 1000;

      if (!isJPG) {
        this.$message.error("图片格式不对");
      }
      return isJPG;
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.handleAdd();
      this.$nextTick(() => {
        this.form.status = 1;
        this.conTypeArr = [{ url: "" }, { url: "" }, { url: "" }];
        this.$refs.form.clearValidate();
        // this.conTypeFiles = [{ url: "" }, { url: "" }, { url: "" }];
      });
    },
    // 修改弹窗
    handleClick(row) {
      this.count = 0;
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      this.html2 = this.form.content;

      if (this.form.category_ids) {
        const stt = this.form.category_ids.split(",").map(Number);
        this.form.category_ids = stt;
      }
      if (this.form.tag_ids) {
        const stts = this.form.tag_ids.split(",").map(Number);
        this.form.tag_ids = stts;
      }
      //   this.conTypeFiles.push({ pic: this.form.article_imgs });
      if (this.form.article_imgs) {
        let formImgs =  JSON.parse(this.form.article_imgs)

        formImgs.map((res) => {
          this.conTypeFiles.push({ url: res });
        });
      }
      this.conTypeArr = JSON.parse(JSON.stringify(this.conTypeFiles));
      if (this.conTypeArr.length < 3) {
        const difference = 3 - this.conTypeArr.length;
        for (let i = 0; i < difference; i++) {
          this.conTypeArr.push({ url: "" }); // 替换"your_default_url"为您想要添加的默认URL
        }
      }
      this.noneBtnImg = this.conTypeFiles.length >= this.limit;
      this.handleEdit();
    },
    // 点击确定
    submitForms() {
      let paths = this.conTypeFiles.map(function (obj) {
        if (obj.url) {
          return obj.url;
        }
      });
      // this.form.article_imgs = paths;
      this.form.article_imgs = paths.filter(
        (item) => item !== undefined && item !== null
      );
      delete this.form.duration;
      delete this.form.video_img;
      delete this.form.xiaoqu_name;
      if (this.form.category_ids) {
        const str = this.form.category_ids.join(",");
        this.form.category_ids = str;
      }
      if (this.form.tag_ids) {
        const strs = this.form.tag_ids.join(",");
        this.form.tag_ids = strs;
      }
      try {
        // 提交表单
        this.submitForm(this.form.category_ids);
        this.conTypeFiles = [];
        this.form = {};
      } catch (error) {
        // 处理提交失败的情况
        console.error("提交失败:", error);
        // 执行适当的操作，例如显示错误提示信息或进行其他处理
      }
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.conTypeFiles = [];
      this.$refs.form.clearValidate();
      this.form.content = "";
      this.count = 0;
      // this.$refs.addOrEditOpen.scrollTop = 0;
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

  <style scoped>
.alright {
  color: #409eff;
  font-size: 32px;
  transform: translate(1%, 22%);
}
/deep/.dialogHeight2 .el-dialog__body {
  overflow-y: auto;
}
/deep/ .arcWrite .el-dialog__body {
  height: 65vh;
  overflow-y: auto;
  overflow: hidden;
}
/deep/.dialogHeight .el-dialog__body {
  height: 100%;
  overflow: hidden;
}
.chooseImg {
  display: flex;
  align-items: center;
}
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}

.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
.uploadSty .el-upload--picture-card {
  width: 110px;
  height: 110px;
  line-height: 110px;
}
/deep/.disUploadSty .el-upload--picture-card {
  display: none; /* 上传按钮隐藏 */
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.avatar-wrapper {
  position: relative;
}

.el-icon-close {
  position: absolute;
  top: 0;
  right: 6vh;
  cursor: pointer;
}
.el-icon-close:hover {
  color: #409eff;
}
/deep/ .el-dialog__body {
  height: 60vh;
}
</style>


// WEBPACK FOOTER //
// src/views/identity/enterprise.vue